var C = (B, D, v) => new Promise((k, x) => {
  var M = (a) => {
    try {
      p(v.next(a));
    } catch (w) {
      x(w);
    }
  }, r = (a) => {
    try {
      p(v.throw(a));
    } catch (w) {
      x(w);
    }
  }, p = (a) => a.done ? k(a.value) : Promise.resolve(a.value).then(M, r);
  p((v = v.apply(B, D)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getDictLabelSync as Z, getDict as V } from "@oppein/op-utils";
import { postGetAiCancelList as ee } from "../../request/designordercenter/productionOrder/aiOperation/getAiCancelList/post.js";
import { postCreateAiCancel as te } from "../../request/designordercenter/productionOrder/aiOperation/createAiCancel/post.js";
import oe from "../../assets/close.png.js";
import le from "../../assets/money.png.js";
import { defineComponent as ne, useTemplateRef as ae, onMounted as se, openBlock as N, createElementBlock as _, createElementVNode as t, createVNode as c, withCtx as m, createCommentVNode as R, createTextVNode as y, Fragment as j, renderList as re } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as ie } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as n, unref as s } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import ue from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import pe from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import E from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/image/src/Image.js";
import { toDisplayString as h, normalizeStyle as de } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import ce from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/tag/src/Tag.js";
import fe from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import L from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import ge from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const me = { style: { textAlign: "left", marginBottom: "10px", fontSize: "20px" } }, ve = { style: { display: "inline-block", "background-color": "#3370ff", width: "30px", height: "30px", "border-radius": "16px", "text-align": "center", "line-height": "30px", "margin-right": "13px" } }, xe = {
  class: "tw:inline-block tw:ml-3",
  style: { "font-size": "12px", "font-weight": "400", color: "rgba(102, 102, 102, 1)" }
}, be = {
  key: 0,
  class: "tw:inline-block tw:ml-3"
}, ye = { style: { "font-size": "14px", "margin-bottom": "10px" } }, he = { style: { color: "rgba(51, 51, 51, 1)", "text-align": "center", margin: "25px 0" } }, we = { style: { "font-size": "24px", "margin-bottom": "10px" } }, Ce = { key: 0 }, Ne = { style: { overflow: "hidden", "font-weight": "bold", "padding-bottom": "10px" } }, _e = { style: { "text-align": "left", "font-size": "12px", "font-weight": "400", color: "rgba(100, 106, 115, 1)" } }, ke = { style: { color: "red", "font-weight": "bold" } }, ze = { style: { "font-size": "36px", "font-weight": "600", color: "rgba(255, 87, 35, 1)" } }, Te = { style: { "border-bottom": "solid 1px rgba(184, 184, 184, 1)", width: "583px" } }, De = { style: { "margin-left": "10px" } }, Me = { style: { display: "inline-block", "margin-left": "10px", position: "relative", top: "0px" } }, Se = { style: { width: "100%", display: "flex", "justify-content": "right" } }, Ke = /* @__PURE__ */ ne({
  __name: "aiCancelDialog.ce",
  emits: ["submit"],
  setup(B, { expose: D, emit: v }) {
    const k = ae("aiCancelDialogContainer"), x = ie(), M = (o) => !o || /^\d+$/.test(o), r = n(!1);
    n("");
    const p = n([]), a = n(!1), w = n([]), $ = n([]), U = () => C(this, null, function* () {
      const [o, e] = yield Promise.all([V("ROOT_brand"), V("ROOT_category")]);
      w.value = o, $.value = e;
    });
    n([]);
    const S = n({
      orderId: ""
    });
    se(() => C(this, null, function* () {
      yield U();
    }));
    function q(o, e = "yyyy-MM-dd HH:mm:ss") {
      const l = typeof o == "string" || typeof o == "number" ? new Date(o) : o;
      if (isNaN(l.getTime()))
        return "";
      const g = (A) => A.toString().padStart(2, "0"), X = {
        yyyy: l.getFullYear().toString(),
        MM: g(l.getMonth() + 1),
        dd: g(l.getDate()),
        HH: g(l.getHours()),
        mm: g(l.getMinutes()),
        ss: g(l.getSeconds())
      };
      return e.replace(/yyyy|MM|dd|HH|mm|ss/g, (A) => X[A] || "");
    }
    const G = (o) => (o = "1012", {
      "-1": { background: "rgba(255, 240, 239, 1)", color: "rgba(227, 73, 39, 1)" },
      1022: { background: "rgba(255, 240, 239, 1)", color: "rgba(227, 73, 39, 1)" },
      1015: { background: "rgba(255, 240, 239, 1)", color: "rgba(227, 73, 39, 1)" },
      1012: { background: "rgba(255, 245, 234, 1)", color: "rgba(255, 130, 3, 1)" }
    }[o] || {
      background: "rgba(52, 199, 36, 0.2)",
      color: "rgba(35, 123, 25, 1)"
    }), f = n("0"), O = n(""), H = n(!1), d = n(0), P = () => C(this, null, function* () {
      try {
        a.value = !0;
        const o = yield ee(S.value);
        o && o.data && o.status ? (a.value = !1, p.value = o.data.CostDetails || [], d.value = 0, p.value.forEach((e) => {
          let l = (e && !isNaN(Number(e.Cost || 0)) ? Number(e.Cost || 0).toFixed(2) : 0) || 0;
          d.value = Number((Number(d.value) + Number(l)).toFixed(2));
        }), O.value = q(/* @__PURE__ */ new Date(), "yyyy-MM-dd HH:mm:ss"), I(), r.value = !0) : (console.warn("获取数据失败：response 或 data 为空"), a.value = !1, I());
      } catch (o) {
        a.value = !1, console.error("请求失败:", o), p.value = [];
      }
    }), z = n(!1), F = n(!1), b = n(60);
    let i = null;
    n(60), n(!1);
    const Y = () => {
      F.value = !1, z.value = !1, i && (clearTimeout(i), i = null), b.value = 60, T([""]), r.value = !1;
    }, J = () => {
      if (console.log(
        "cancelCostNumInput !== cancelCostNum",
        Number(f.value) !== d.value,
        Number(f.value),
        d.value
      ), !f.value || Number(f.value) !== d.value) {
        x.error("手工录入的取消生产预计费用与系统提示金额不一致!");
        return;
      }
      K();
    }, I = () => {
      i = setTimeout(() => {
        b.value--, console.log("countdown-----", b.value), b.value > 0 ? I() : (i && (clearTimeout(i), i = null), T([""]), r.value = !1, z.value = !1, b.value = 60);
      }, 1e3);
    }, K = () => C(this, null, function* () {
      var o;
      a.value = !0, z.value = !1, F.value = !1;
      try {
        const e = yield te({
          orderId: S.value.orderId,
          mscsTotalAmount: d.value || 0,
          //.toString(),
          mscsTotalAmountDate: O.value || "",
          confirmTotalAmount: f.value || ""
        });
        a.value = !1, z.value = !1, i && (clearTimeout(i), i = null), b.value = 60, e && e.status ? ((o = e.data) != null && o.Success, x.success(
          "订单已提交取消申请，请于5分钟后在订单详情-审批列表中刷新查看订单取消结果"
        ), T([""]), r.value = !1) : (T([""]), r.value = !1);
      } catch (e) {
        a.value = !1, console.error("取消订单失败:", e);
      }
    }), u = n({});
    function Q(o) {
      S.value.orderId = o.orderId || "", u.value = o || {}, P();
    }
    const T = (o) => {
      console.log("submit", o), r.value = !1, W("submit", o);
    }, W = v;
    return D({ open: Q }), (o, e) => (N(), _(j, null, [
      t("div", {
        ref_key: "aiCancelDialogContainer",
        ref: k
      }, null, 512),
      c(s(ge), {
        bordered: "",
        show: r.value,
        "onUpdate:show": e[3] || (e[3] = (l) => r.value = l),
        "mask-closable": !1,
        "z-index": 9999,
        to: k.value || "body"
      }, {
        default: m(() => [
          c(s(ue), { show: a.value }, {
            default: m(() => [
              c(s(pe), {
                style: { width: "655px" },
                title: "",
                bordered: !1,
                role: "dialog"
              }, {
                default: m(() => [
                  t("div", me, [
                    t("span", ve, [
                      c(s(E), {
                        width: "16px",
                        height: "21px",
                        src: s(le)
                      }, null, 8, ["src"])
                    ]),
                    e[4] || (e[4] = t("span", { style: { "font-size": "20px", "font-weight": "600" } }, "取消费用预估", -1)),
                    t("span", xe, h(u.value && u.value.productionOrderContractNo || "暂无数据"), 1),
                    u.value && u.value.status ? (N(), _("span", be, [
                      t("span", {
                        style: de([{ padding: "3px 7px", "font-size": "12px", "font-weight": "400" }, G(u.value && u.value.status)])
                      }, h(u.value.statusName || s(Z)(u.value && u.value.status, "pro_order_status")), 5)
                    ])) : R("", !0)
                  ]),
                  t("div", ye, [
                    t("div", he, [
                      c(s(ce), {
                        type: "warning",
                        style: { width: "100%", height: "36px", "line-height": "36px", "text-align": "center", display: "inline-block", color: "rgba(31, 35, 41, 1)", "font-size": "14px", "font-weight": "400" }
                      }, {
                        default: m(() => e[5] || (e[5] = [
                          t("span", { style: { display: "inline-block", "background-color": "rgba(255, 136, 0, 1)", width: "16px", height: "16px", "border-radius": "8px", "text-align": "center", "line-height": "16px", color: "#fff", "margin-right": "10px" } }, "!", -1),
                          y(" 页面1分钟后将自动关闭 ", -1)
                        ])),
                        _: 1,
                        __: [5]
                      })
                    ])
                  ]),
                  t("div", we, [
                    t("div", null, [
                      H.value && p.value.length > 0 ? (N(), _("div", Ce, [
                        e[6] || (e[6] = t("div", { style: { display: "flex", "justify-content": "space-between", "align-items": "center", margin: "10px", "font-size": "20px", "font-weight": "bold" } }, [
                          t("span", null, "二级品类"),
                          t("span", null, "取消金额")
                        ], -1)),
                        (N(!0), _(j, null, re(p.value, (l, g) => (N(), _("div", {
                          style: { display: "flex", "justify-content": "space-between", "align-items": "center", "margin-bottom": "10px", "font-size": "16px" },
                          key: g
                        }, [
                          t("span", null, h(l.Category), 1),
                          y(" " + h((l.Cost && !isNaN(Number(l.Cost)) ? Number(l.Cost).toFixed(2) : "0.00") || "0.00"), 1)
                        ]))), 128))
                      ])) : R("", !0),
                      t("div", Ne, [
                        e[7] || (e[7] = t("span", { style: { "text-align": "left", "font-size": "16px", "font-weight": "400", color: "rgba(31, 35, 41, 1)" } }, "取消生产预计费用(元)", -1)),
                        t("div", _e, " 费用获取时间: " + h(O.value || ""), 1),
                        t("div", ke, [
                          t("span", ze, "￥" + h(d.value), 1),
                          t("span", {
                            style: { "font-size": "14px", "font-weight": "400", color: "rgba(36, 111, 253, 1)", cursor: "pointer", "margin-left": "10px" },
                            onClick: e[0] || (e[0] = (l) => H.value = !H.value)
                          }, "查看明细")
                        ])
                      ]),
                      t("div", Te, [
                        e[9] || (e[9] = t("span", {
                          class: "tw:inline-block tw:mb-2",
                          style: { "text-align": "left", "font-size": "16px", "font-weight": "400", color: "rgba(31, 35, 41, 1)" }
                        }, "取消生产费用(元)", -1)),
                        t("div", De, [
                          e[8] || (e[8] = t("span", { style: { display: "inline-block", "font-size": "36px", "font-weight": "600" } }, "￥", -1)),
                          t("div", Me, [
                            c(s(fe), {
                              type: "text",
                              value: f.value,
                              "onUpdate:value": e[2] || (e[2] = (l) => f.value = l),
                              "allow-input": M,
                              placeholder: String(d.value),
                              style: { "--n-border": "none", width: "524px", "font-size": "36px", "font-weight": "600" }
                            }, {
                              suffix: m(() => [
                                t("span", {
                                  onClick: e[1] || (e[1] = (l) => f.value = ""),
                                  style: { display: "inline-block", width: "21px", height: "21px", "border-radius": "12px", "text-align": "center", "line-height": "21px", cursor: "pointer", position: "relative", left: "12px" }
                                }, [
                                  c(s(E), {
                                    width: "21px",
                                    height: "21px",
                                    src: s(oe)
                                  }, null, 8, ["src"])
                                ])
                              ]),
                              _: 1
                            }, 8, ["value", "placeholder"])
                          ])
                        ])
                      ]),
                      e[10] || (e[10] = t("div", {
                        style: { "font-size": "14px", "font-weight": "400", "letter-spacing": "0px", "line-height": "19.6px", color: "rgba(100, 106, 115, 1)", "text-align": "left" },
                        class: "tw:mt-2"
                      }, " 如需更改金额，请重新输入 ", -1))
                    ])
                  ]),
                  e[13] || (e[13] = t("div", { style: { width: "583px", height: "120px", opacity: "1", "border-radius": "8px", background: "rgba(246, 248, 249, 1)", padding: "20px", "font-size": "14px", "font-weight": "400", color: "rgba(100, 106, 115, 1)" } }, [
                    t("div", { class: "tw:mb-2" }, [
                      t("span", null, [
                        y(" 1、可能产生委外物料的费用， "),
                        t("span", { style: { "font-size": "14px", "font-weight": "400", "letter-spacing": "0px", "line-height": "25px", color: "rgba(255, 87, 35, 1)" } }, "最终金额以实际结算为准；")
                      ])
                    ]),
                    t("div", { class: "tw:mb-2" }, "2、取消订单后，定制产品已生产默认不发货，标准品已生产默认发货。"),
                    t("div", { class: "tw:mb-2" }, [
                      y(" 3、此费用不包含服务费 "),
                      t("span", { style: { "font-size": "14px", "font-weight": "400", "letter-spacing": "0px", "line-height": "25px", color: "rgba(255, 87, 35, 1)" } }, "（橱卫50元/单；衣木30元/单）")
                    ])
                  ], -1)),
                  t("div", Se, [
                    c(s(L), {
                      onClick: Y,
                      style: { "margin-top": "22px", "border-radius": "5px" }
                    }, {
                      default: m(() => e[11] || (e[11] = [
                        y("关闭", -1)
                      ])),
                      _: 1,
                      __: [11]
                    }),
                    c(s(L), {
                      onClick: J,
                      style: { "margin-left": "30px", "margin-top": "22px", "background-color": "#3370ff !important", "border-color": "#3370ff !important", "--n-border": "1px solid #3370ff", "--n-button-color": "#fff !important", "border-radius": "5px" },
                      type: "primary"
                    }, {
                      default: m(() => e[12] || (e[12] = [
                        y("确认", -1)
                      ])),
                      _: 1,
                      __: [12]
                    })
                  ])
                ]),
                _: 1,
                __: [13]
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  Ke as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-cancel-dialog/aiCancelDialog.ce.vue2.js
// module id = 1146
// module chunks = 41